import { ColumnHeader } from "export-to-csv";
import { TFunction } from "i18next";

export const getOperatorCSVHeaders = (t: TFunction<"translation", undefined>) =>
  [
    { displayLabel: t("core:CSV.HEADERS.NAME"), key: "name" },
    {
      displayLabel: t("core:CSV.HEADERS.DESCRIPTION"),
      key: "description",
    },
    {
      displayLabel: t("core:CSV.HEADERS.BUSINESS_TYPE"),
      key: "businessType",
    },
    { displayLabel: t("core:CSV.HEADERS.EMAIL"), key: "email" },
    { displayLabel: t("core:CSV.HEADERS.PHONE"), key: "phone" },
    {
      displayLabel: t("core:CSV.HEADERS.ADDRESS"),
      key: "address",
    },
    {
      displayLabel: t("core:CSV.HEADERS.WEBSITE"),
      key: "website",
    },
    { displayLabel: t("core:CSV.HEADERS.STATUS"), key: "status" },
    { displayLabel: t("core:CSV.HEADERS.STAFF"), key: "staff" },
    {
      displayLabel: t("core:CSV.HEADERS.PRICING"),
      key: "pricing",
    },
    {
      displayLabel: t("core:CSV.HEADERS.BACK_OFFICE_TAGS"),
      key: "backOfficeTags",
    },
  ] as ColumnHeader[];
